import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import ApolloClient from "apollo-client";
import React, { Component } from "react";
import { MutationFunction } from "react-apollo";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Loading from "../../../componentes/Loading/Loading";
import LogoConcilia from "../../../componentes/LogoConcilia";
import { ModoTemaContext } from "../../../styles/theme/modoTema";
import SnackMessage from "../../../componentes/SnakBar";
import {
  EstabelecimentoDownloadDocument,
  UploadDocsEstabelecimentoProps,
  ValidarPendenciaCaadastroOperadoraComponent,
  ValidarPendenciaCaadastroOperadoraMutation,
  ValidarPendenciaCaadastroOperadoraMutationVariables,
  withUploadDocsEstabelecimento,
} from "../../../graphql/components";
import { allowConciliador } from "../../../redux/actions/allowAction";
import CadastrarTaxas from "./cadastrarTaxas";
import { obterDocumento } from "./documentoEstabelecimento";
import ListaEstabelecimentos from "./listaEstabelecimentos";
import "./painelCadastro.css";
import TablePainelCadastro from "./tablePainelCadastro";
import UploadPainelCadastro from "./uploadPainelCadastro";
import VisualizadorDocumento from "./visualizadorDocumento";

const Transition = React.forwardRef<unknown, React.ComponentProps<typeof Slide>>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...(props as React.ComponentProps<typeof Slide>)} />;
});

interface Props {
  isPainelCadastroOpen: boolean;
  download?: () => Promise<any>;
  closePainelCadastro: () => void;
  allowConciliador: typeof allowConciliador;
}

interface State {
  open: boolean;
  listaEC: boolean;
  cadastroTaxa: boolean;
  loading: boolean;
  uploadOpen: boolean;
  files?: Array<File>;
  codOperadoraUpload?: number;
  codOperadora?: number;
  nomeOperadora?: string;
  uploading: boolean;
  tipoDocUpload?: string;
  variantSnack: "success" | "warning" | "error" | "info";
  message: string;
  openSnackMessage: boolean;
  mensagemRetorno: boolean;
  viewDoc: boolean;
  linkDoc?: string; 
}

class PainelCadastro extends Component<UploadDocsEstabelecimentoProps<Props>, State> {
  static contextType = ModoTemaContext;

  static defaultProps = {
    isPainelCadastroOpen: false,
  };

  constructor(props: UploadDocsEstabelecimentoProps<Props>) {
    super(props);
    this.state = {
      open: false,
      listaEC: false,
      cadastroTaxa: false,
      loading: false,
      uploadOpen: false,
      files: undefined,
      codOperadoraUpload: undefined,
      codOperadora: undefined,
      nomeOperadora: undefined,
      uploading: false,
      tipoDocUpload: undefined,
      variantSnack: "success",
      message: "",
      openSnackMessage: false,
      mensagemRetorno: false,
      viewDoc: false
    };
  }

  handleCloseUpload = () => this.setState({ uploadOpen: false });

  mensagemRetorno = (mensagemRetorno: boolean) => {
    if (mensagemRetorno) {
      this.setState({
        openSnackMessage: true,
        message: "Registro salvo com sucesso!",
        variantSnack: "success",
      });
    }
  };

  closeSnackMessage = () => this.setState({ openSnackMessage: false });

  upload = (codoperadora: number, tipoDocUpload: string) =>
    this.setState({
      uploadOpen: true,
      codOperadoraUpload: codoperadora,
      tipoDocUpload,
    });

  setUpload = (files: Array<File>) => this.setState({ files });

  realizeUpload = () => {
    this.setState({ uploading: true });
    const reader = new FileReader();
    reader.onload = async () => {
      const bytesArray = reader.result;
      const response = await this.props.mutate({
        variables: {
          nameFile: this.state.files![0].name,
          tipoDoc: this.state.tipoDocUpload!,
          file: bytesArray as any,
          values: { codoperadora: this.state.codOperadoraUpload },
        },
        refetchQueries: ["getPainelCadastro", "canUpload"],
        awaitRefetchQueries: true,
      });
      this.setState({ uploading: false });
      if (response) {
        if (response.data!.uploadDocsEstabelecimento!) {
          this.setState({
            uploadOpen: false,
            message: "Upload realizado com sucesso!",
            variantSnack: "success",
            files: undefined,
          });
        }
      }
    };
    reader.readAsBinaryString(this.state.files![0]);
  };

  download = async (tipoDocumento: string, client: ApolloClient<any>, codoperadora: number) => {
    this.setState({ loading: true, viewDoc: true, linkDoc: undefined });

    const resultado = await obterDocumento(
      () =>
        client.query({
          query: EstabelecimentoDownloadDocument,
          variables: { values: { codoperadora }, tipoDocumento },
        }),
      process.env.REACT_APP_HOST
    );

    if (resultado.erro) {
      this.setState({
        loading: false,
        viewDoc: false,
        linkDoc: undefined,
        openSnackMessage: true,
        message: resultado.erro,
        variantSnack: "warning",
      });
      return;
    }

    this.setState({ loading: false, linkDoc: resultado.url });
  };

  close = () => this.setState({ open: false });

  prosseguir = async (
    mutation: MutationFunction<ValidarPendenciaCaadastroOperadoraMutation, ValidarPendenciaCaadastroOperadoraMutationVariables>
  ) => {
    this.setState({ loading: true });
    const response = await mutation();
    if (response) {
      if (
        response.data!.validarPendenciaCadastroOperadora === "MENU" ||
        response.data!.validarPendenciaCadastroOperadora === "NENHUMA OPERADORA LIBERADA PARA CADASTRO"
      ) {
        this.setState({ loading: false });
        this.props.allowConciliador();
        this.props.closePainelCadastro();
      } else {
        this.setState({
          openSnackMessage: true,
          message: response.data!.validarPendenciaCadastroOperadora!,
          variantSnack: "warning",
        });
        this.setState({ loading: false });
        this.props.closePainelCadastro();
      }
    }
  };

  openListaEC = () => this.setState({ listaEC: true });

  handleCloseListaEC = () => this.setState({ listaEC: false });

  openCadastroTaxa = (nomeOperadora: string, codOperadora: number, mensagem: string) => {
    if (mensagem === "TAXA") {
      this.setState({
        cadastroTaxa: true,
        nomeOperadora: nomeOperadora,
        codOperadora: codOperadora,
      });
    } else {
      this.setState({
        cadastroTaxa: false,
        openSnackMessage: true,
        message: mensagem,
        variantSnack: "warning",
      });
    }
  };

  handleCloseCadastroTaxa = () => this.setState({ cadastroTaxa: false });

  handleCloseViewDoc = () => this.setState({ viewDoc: false });

  render() {
    const { isPainelCadastroOpen } = this.props;
    const { files } = this.state;
    return (
      <Dialog
        fullScreen
        className={(this.context as React.ContextType<typeof ModoTemaContext>).modo === "dark" ? "painelCadastroEscuro" : undefined}
        classes={{ paper: "painelCadastroPapel" }}
        open={isPainelCadastroOpen}
        TransitionComponent={Transition as any}
        onClose={this.close}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" className="painelTitulo">
          Painel para Cadastro de Estabelecimentos
          <LogoConcilia classe="painelLogo" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" component="div">
            {this.state.loading ? (
              <Loading />
            ) : (
              <TablePainelCadastro
                openListaEC={this.openListaEC}
                openCadastroTaxa={this.openCadastroTaxa}
                mensagemRetorno={this.mensagemRetorno}
                download={this.download}
                upload={this.upload}
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!this.state.loading ? (
            <ValidarPendenciaCaadastroOperadoraComponent>
              {(mutation) => (
                <div style={{ flex: 100, padding: 18, textAlign: "right" }}>
                  <Button
                    id="prosseguir"
                    onClick={this.prosseguir.bind(this, mutation)}
                    className="painelContinuar"
                  >
                    Continuar
                  </Button>
                </div>
              )}
            </ValidarPendenciaCaadastroOperadoraComponent>
          ) : null}
        </DialogActions>

        {this.state.listaEC && (
          <Dialog fullScreen open={this.state.listaEC} onClose={this.handleCloseListaEC} TransitionComponent={Transition as any}>
            <AppBar style={{ position: "relative" }}>
              <Toolbar>
                <IconButton color="inherit" onClick={this.handleCloseListaEC} aria-label="Fechar">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
                  LISTA DE ESTABELECIMENTOS
                </Typography>
              </Toolbar>
            </AppBar>
            <ListaEstabelecimentos />
          </Dialog>
        )}

        {this.state.cadastroTaxa && (
          <CadastrarTaxas
            handleClose={this.handleCloseCadastroTaxa}
            open={this.state.cadastroTaxa}
            nomeOperadora={this.state.nomeOperadora}
            codOperadora={this.state.codOperadora}
            mensagemRetorno={this.mensagemRetorno}
          />
        )}

        {this.state.uploadOpen && (
          <UploadPainelCadastro
            open={this.state.uploadOpen}
            handleCloseUpload={this.handleCloseUpload}
            files={files}
            realizeUpload={this.realizeUpload}
            setUpload={this.setUpload}
            uploading={this.state.uploading}
            tipoDoc={this.state.tipoDocUpload!}
            codoperadora={this.state.codOperadoraUpload!}
          />
        )}
        {this.state.message && this.state.message.length > 0 && (
          <SnackMessage
            close={this.closeSnackMessage}
            open={this.state.openSnackMessage}
            variant={this.state.variantSnack}
            message={this.state.message}
          />
        )}

        {this.state.viewDoc && (
          <Dialog fullScreen open={this.state.viewDoc} onClose={this.handleCloseViewDoc} TransitionComponent={Transition as any}>
            <AppBar style={{ position: "relative" }}>
              <Toolbar>
                <IconButton color="inherit" onClick={this.handleCloseViewDoc} aria-label="Fechar">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
                  DOCUMENTO
                </Typography>
              </Toolbar>
            </AppBar>
            {this.state.loading ? <Loading /> : <VisualizadorDocumento url={this.state.linkDoc} />}
          </Dialog>
        )}
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  allowConciliador: bindActionCreators(allowConciliador, dispatch),
});

const withMutate = withUploadDocsEstabelecimento<Props>({});

const withMutation = withMutate(PainelCadastro);

const PainelCadastroConnected = connect(
  null,
  mapDispatchToProps
)(withMutation);

export default PainelCadastroConnected;
